import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {filter, Subscription} from 'rxjs';
import {AuthService} from '../../../services/auth.service';
import {NavigationEnd, Router} from '@angular/router';
import {User} from '../../../models/user.model';

@Component({
  selector: 'app-top-navbar',
  templateUrl: './top-navbar.component.html',
  styleUrls: ['./top-navbar.component.css']
})
export class TopNavbarComponent implements OnInit, OnDestroy {

  @ViewChild('toggleNavbar') toggleNavbar: ElementRef;
  @Input() title: string;
  routerSubscription: Subscription;
  userSubscription: Subscription;
  queueListSubjectSubscription: Subscription;
  selectedLanguageSubscription: Subscription;
  balanceSubscription: Subscription;
  systemLanguagesSubscription: Subscription;
  loaded: boolean;
  isLoggedIn: boolean;
  isCollapsed: boolean;
  explodeDataFlowActive: boolean;
  user: User;


  constructor(
    private authService: AuthService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.isCollapsed = true;

    this.routerSubscription = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((navigationObj: NavigationEnd) => {
      const urlArray = navigationObj.url.split('/');
      this.explodeDataFlowActive = urlArray.length > 2 && urlArray[1] === 'data';
    })

    this.registerUserSubscription();
  }

  registerUserSubscription() {
    this.userSubscription = this.authService.userSubject.subscribe(user => {
      this.loaded = true;
      this.user = user;
      this.isLoggedIn = !!user;
    });
  }

  onLogout() {
    this.authService.onLogout();
  }

  onCloseNavbar() {
    this.toggleNavbar.nativeElement.click();
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.balanceSubscription) {
      this.balanceSubscription.unsubscribe();
    }
    if (this.queueListSubjectSubscription) {
      this.queueListSubjectSubscription.unsubscribe();
    }
    if (this.selectedLanguageSubscription) {
      this.selectedLanguageSubscription.unsubscribe();
    }
    if (this.systemLanguagesSubscription) {
      this.systemLanguagesSubscription.unsubscribe();
    }
  }
}
